import { atom } from 'jotai'
import { IFetchAccountTeam } from '../types'

type IAccountTeamsState = Array<IFetchAccountTeam> | null

const defaultState: IAccountTeamsState = null

// base atom with initial value
export const accountTeamsAtom = atom<IAccountTeamsState>(defaultState)